import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { PageLayout } from '@/ui/layouts/PageLayout'

export function VaultsContainerSkeleton() {
  return (
    <PageLayout className="max-w-6xl gap-4 px-3">
      {/* Header skeleton */}
      <div className="flex flex-col gap-4">
        <Skeleton className="h-10 w-32" />
        <Skeleton className="h-5 w-80" />
      </div>

      {/* Tab bar skeleton */}
      <div className="flex gap-4 sm:gap-8 items-center justify-between">
        <div className="flex gap-4 sm:gap-8">
          <Skeleton className="h-6 w-28" />
          <Skeleton className="h-6 w-24" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-5 w-10 rounded-full" />
        </div>
      </div>

      {/* Cards grid skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div
            key={i}
            className="flex flex-col items-start p-8 gap-5 bg-[#111114] border border-white/[0.04] rounded-2xl"
          >
            <div className="flex flex-row justify-between items-center w-full">
              <div className="flex flex-row items-center gap-2">
                <Skeleton className="h-9 w-9 rounded-full" />
                <div className="flex flex-col gap-1">
                  <Skeleton className="h-5 w-24" />
                  <Skeleton className="h-3 w-16" />
                </div>
              </div>
              <div className="flex flex-col items-end gap-1">
                <Skeleton className="h-3 w-12" />
                <Skeleton className="h-5 w-16" />
              </div>
            </div>
            <div className="flex flex-row justify-between items-center w-full">
              <div className="flex flex-col gap-2">
                <Skeleton className="h-3 w-10" />
                <Skeleton className="h-5 w-20" />
              </div>
              <div className="flex flex-col items-end gap-2">
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-5 w-24" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </PageLayout>
  )
}

